import { render, staticRenderFns } from "./IframeViewer.vue?vue&type=template&id=61e5c43e&"
import script from "./IframeViewer.vue?vue&type=script&lang=js&"
export * from "./IframeViewer.vue?vue&type=script&lang=js&"
import style0 from "./IframeViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports